// Static snapshot of recent mobile-app (~/shado) commit history for the Dev Timeline admin screen.
// Generated from: git -C /Users/evancarter/shado log --no-merges -n 60 --date=short --pretty=format:'%H|%ad|%an|%s'
// This is a BUILD-TIME snapshot, not live data — regenerate this file and re-deploy to refresh it.
// Snapshot date: 2026-07-10

export type DevTimelineCommit = {
  hash: string;
  date: string;
  author: string;
  subject: string;
};

export const DEV_TIMELINE_SNAPSHOT_DATE = "2026-07-10";

export const devTimelineCommits: DevTimelineCommit[] = [
  {
    "hash": "258c5bcfe4889903cbf016d8d76eabb94fa4e3ac",
    "date": "2026-07-10",
    "author": "Evan Carter",
    "subject": "Consolidate OUTSTANDING: 'THE LIST' prioritized front door (App track NOW/PASS/SOON/DISCUSS + Admin-dash full-expansion track + strategy) merging tabled pass + 07-10 brain-dump"
  },
  {
    "hash": "15629b3bc5f07e2a304306e0e04a6c153d043b03",
    "date": "2026-07-10",
    "author": "Evan Carter",
    "subject": "Capture Evan 07-10 brain-dump into OUTSTANDING (30 items bucketed: bugs/features/discuss/admin/strategy/ideas) + pass reconciliation notes"
  },
  {
    "hash": "72648fc694a4f7b85e6a8b599a5be186a4afea41",
    "date": "2026-07-05",
    "author": "Evan Carter",
    "subject": "Pass mockups v2 HTML (all 07-05 feedback applied)"
  },
  {
    "hash": "57c1a6cccf2be280700a746da98e06c5d214a0d4",
    "date": "2026-07-05",
    "author": "Evan Carter",
    "subject": "Pass mockups v2 (Evan 07-05 feedback: sort placement+city scope, tag scoping, under-username rank lines, CTA glow surfaces, 30d feed lean) + decisions recorded"
  },
  {
    "hash": "54534c5c92d83ce62acdad0bc6a7261152707f7f",
    "date": "2026-07-05",
    "author": "Evan Carter",
    "subject": "Pass mockups HTML: all 9 visual elements before/after (+2 behavioral noted) in 'to open/'"
  },
  {
    "hash": "b61e2f2bbcbde4abde0ee1085bff93c41ff5a2eb",
    "date": "2026-07-05",
    "author": "Evan Carter",
    "subject": "Pass decisions locked (Evan 07-05): header sort button, H-4+cursor bundle, follows-only feed (no stranger content), avatar rings only"
  },
  {
    "hash": "b732b8552dda43e771b87be15b2b84c065c5ff73",
    "date": "2026-07-04",
    "author": "Evan Carter",
    "subject": "shado-admin pointer: heat density tune deployed"
  },
  {
    "hash": "b3cd898db6e0394575347236647aa8e5083ce7d1",
    "date": "2026-07-04",
    "author": "Evan Carter",
    "subject": "Queue: feed-depth item with full investigation (7-day cutoff root cause; 42% blank-feed rate; fix menu) + Issue-5 doc-drift correction"
  },
  {
    "hash": "c505527334eacc4138783f95234e5f05282ec872",
    "date": "2026-07-04",
    "author": "Evan Carter",
    "subject": "shado-admin pointer: Geography v2 (smooth zoom + gradient heat) deployed"
  },
  {
    "hash": "cfd35bd736bc7336b81fe51b0484d7dc2dced6fd",
    "date": "2026-07-04",
    "author": "Evan Carter",
    "subject": "shado-admin pointer: Geography heatmap tab deployed"
  },
  {
    "hash": "fa6450262fe2c6a127d2aafaa97ebc00dc7b6e46",
    "date": "2026-07-04",
    "author": "Evan Carter",
    "subject": "Table the post-launch pass (recorded verbatim: 7 items + bundle candidates + Evan's rejections)"
  },
  {
    "hash": "56c2296d37bcd5ddec9e212c7263785e9bed5b67",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Move all viewer HTMLs to 'to open/' folder (Evan-findable) + README"
  },
  {
    "hash": "f0bc738edcb7e25859fac3ef879058993e9e033c",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Docs: RETRACTED FEATURES ledger + render-path verification rule (thought-tag filter false-SHIPPED corrected — UI retracted, only plumbing remains)"
  },
  {
    "hash": "88e95240b662efd484d53e3ffb014f501cb3ef78",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "shado-admin pointer: product-polish deploy"
  },
  {
    "hash": "a82971e482c9e02755458cc5ae3025cfc85f9e0b",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "State-of-app report 2026-07-04 (DB-truth metrics, no DAU/WAU) + IG/onboarding content library v1"
  },
  {
    "hash": "1d3c9ca14f7dd0e6856c9b86a60db4d4abacd164",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Brain sync 2026-07-04: full session record (security batch, 7 OTAs, force-update all-lanes, data fixes, dash upgrades) + OUTSTANDING refresh"
  },
  {
    "hash": "fd7aefa67fa0da4c82c92c0078bdff249c663b01",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Home-city normalization: merge USA/United States leaderboard splits + NYC name canonicalization + write-guard trigger"
  },
  {
    "hash": "7ff7c2c65de783702800cdfcffc31166305fdaae",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Notification deep-link back-loop fix + \"Search and Rate\" empty-state copy"
  },
  {
    "hash": "fdde9cad29857a1ef432d125d044eff85c1ef5d8",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "City-link integrity: 30km blanket + DC 10km radius (server, applied) + Cambridge same-name city fix (client)"
  },
  {
    "hash": "8aba26327b9e3887018d032193f6b523e2e0d3b4",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Past-ratings carousel: single interleaved visit timeline (Evan spec)"
  },
  {
    "hash": "28939982c157529aa7908decc3e9e1b87092595e",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Polish: Near Me empty-state button \"Rate it\"→\"Rate\"; public-profile stat row (gap 8, Followers cell flex 1.35 so all labels render same size, three left cells shift left)"
  },
  {
    "hash": "0396a0942ab461d98cd04d42fcaee1e6ec4769f4",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Ship record: force-update retrofit to ALL lanes (1.1.3-1.1.8) + admin per-version toggles deployed + sort revert"
  },
  {
    "hash": "03020eca98938be68e5bb63d7af17458bad8f4bb",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Revert Near Me sort feature (Evan on-device call): filter sheet back to All/Clubs/Bars + Community + Friends score"
  },
  {
    "hash": "90abea96768701703d97bedd7a9405b973ce0e13",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Force-update gate v2: per-version blocked[] list (admin per-version toggles) alongside min-version"
  },
  {
    "hash": "8d59e3e4a5da409ee64f114152f9106996f50a5f",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "Ship record 2026-07-03: cold-open+polish OTA live (group e01ad506, rt 1.1.8) + admin dash deployed"
  },
  {
    "hash": "aa01d9ec7ca09ba95a6de687813651fce3bf28b3",
    "date": "2026-07-03",
    "author": "Evan Carter",
    "subject": "OTA 2026-07-03: cold-open perf + Near Me sort + PYMK polish + force-update gate + legal refresh"
  },
  {
    "hash": "ed360cc4b6df14efb91e86c0b0b28e553224d2d8",
    "date": "2026-07-02",
    "author": "Evan Carter",
    "subject": "Security batch 2026-07-02 (audit): H-3 admin-gate + CH-2 recursion fix + H-1 venue column-grant + H-2 likes/replies log-visibility"
  },
  {
    "hash": "3fe13426c58877c2785924e3944a66e9e8db1c68",
    "date": "2026-07-02",
    "author": "Evan Carter",
    "subject": "Brain sync 2026-07-02: audit + atlas + design proposals; correct drifted state docs; capture launch decisions"
  },
  {
    "hash": "81ebeb1264c47cfae8d10b0e4005267033791a70",
    "date": "2026-07-02",
    "author": "Evan Carter",
    "subject": "Handoff: Discover/Feed perf audit → IMPLEMENTATION_QUEUE Issues 4-6 (Evan-approved to execute)"
  },
  {
    "hash": "cdd97c6e638ebc7058fc10d25aaaebfa91ba8ee4",
    "date": "2026-07-01",
    "author": "Evan Carter",
    "subject": "Near Me: keep grid mounted through venue open (Option A) + >20km empty state"
  },
  {
    "hash": "7d8a3957cfad526eabe474e3c00e89e40109ced2",
    "date": "2026-07-01",
    "author": "Evan Carter",
    "subject": "Batch 2026-07-01: city-link/DC/compare/flash/accept/music/captions/orientation/keyboard/apple-name"
  },
  {
    "hash": "6dd7a1fb9c0d4de1774b44ba5b000a62f809e4c5",
    "date": "2026-06-29",
    "author": "Evan Carter",
    "subject": "CRITICAL hotfix: replies RLS infinite recursion (all reply inserts failing)"
  },
  {
    "hash": "9238d99641b8c7c9d38a2a23ade231e15d6cca3a",
    "date": "2026-06-29",
    "author": "Evan Carter",
    "subject": "1.1.8 OTA: Discover back-navigation scroll/state fixes (queue issues 1-3)"
  },
  {
    "hash": "38e132e1e157f0ab0b19fcced84d3264b7ea2c1f",
    "date": "2026-06-29",
    "author": "Evan Carter",
    "subject": "Apple-fallback: auto-link in-corpus typos to the universal name + seed alias (DB-only)"
  },
  {
    "hash": "362b65a857aedcc6218b2cf616dcbf70a0352286",
    "date": "2026-06-28",
    "author": "Evan Carter",
    "subject": "admin push-announcement RPC: admin_push_announcement_audience (already applied to prod)"
  },
  {
    "hash": "6ba4cfddd6f51b1072ad7f06849a0ac44d506810",
    "date": "2026-06-28",
    "author": "Evan Carter",
    "subject": "1.1.8 OTA: like any public log you can see (client guard) + RLS-audit DB fixes"
  },
  {
    "hash": "289ba2769b5da12b5c0502ea93ab83795517dcd3",
    "date": "2026-06-28",
    "author": "Evan Carter",
    "subject": "1.1.8 OTA: complete replies fix (client comment guard) + get_my_birthdate RPC migration"
  },
  {
    "hash": "e056f5b28e4be82345814a80fd9fdb35a7dec249",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "1.1.8 OTA: floor compare count by real opponents (kill spurious rate-1-more gate) + replies RLS migration"
  },
  {
    "hash": "3db808dc1c065b80f6ccb639b6bd1085115690ac",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "1.1.8 OTA: fix compare stale-cache (no-opponent + spurious gate) + double-accept-push migration"
  },
  {
    "hash": "6bd5f925e05da692e1837532438152c450870f0c",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "1.1.8 OTA: new-rating search = map parity"
  },
  {
    "hash": "96c9661b7931675b47a6c8ea802145233a5e4baa",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Launch 1.1.8: age verification, feed/profile/city fixes, admin features"
  },
  {
    "hash": "4eccbc2e6ff2cd7a76fe0e40f06569d4e99b7c35",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Fix iOS build: compile expo-age-range pod in Swift 5 mode"
  },
  {
    "hash": "efe17d603113f72c546bead498c81152d0471331",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "1.1.8 backend + docs"
  },
  {
    "hash": "5990012e745b1709063c58a41ebbbe984230a3d8",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Release 1.1.8 (app): apple-name compliance, age gate, in-app alerts"
  },
  {
    "hash": "3a9a84fa8933001855c933c9f07fab1d7c25ef39",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Close mutual_follow_user_ids social-graph IDOR"
  },
  {
    "hash": "08095baf04ab392601d0cbe9a85bad841cbef6d9",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Scalability: follow-list keyset RPCs (list_followers/list_following) — applied to prod"
  },
  {
    "hash": "806dbeb95dca849ad7f031ede0589e8301329909",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Scalability increment 1: Near Me geom RPC, scaling indexes, RLS initplan hygiene, cities churn guard (all applied to prod)"
  },
  {
    "hash": "34f399360776757e471433c9f77e2a40865259e5",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Lock down RLS-off public tables + SECURITY DEFINER view (Supabase advisor)"
  },
  {
    "hash": "a350b54cea6d11eaef6c6241d4663f68358e06a9",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "PII durability guard: self-heal profiles read-protection via pg_cron"
  },
  {
    "hash": "842c057daba1ebb07fd973aa4b150fc0c54e00f4",
    "date": "2026-06-27",
    "author": "Evan Carter",
    "subject": "Launch security hardening: close PII leak, self-unsuspend, push-spam; add server-side moderation + cost fail-safes"
  },
  {
    "hash": "d2dca93bcecf597af091c7a25e123812b0aedec8",
    "date": "2026-06-26",
    "author": "Evan Carter",
    "subject": "Stage: Apple venues rateable AND name-compliant (re-add guard + keep placeholder)"
  },
  {
    "hash": "1fdb147f60dd5ba617ebd4bfda7ba34819669f2c",
    "date": "2026-06-26",
    "author": "Evan Carter",
    "subject": "Stage: Apple venues ALWAYS rateable (remove no_user_name block)"
  },
  {
    "hash": "5b3548313a39aac72ec97faafe36f78e7f5596a1",
    "date": "2026-06-26",
    "author": "Evan Carter",
    "subject": "Stage: featured-cities RPCs return filters_unlocked (cold-start filter gate)"
  },
  {
    "hash": "4d4336c21fc2c2c176f44dce045f18d7b21d806a",
    "date": "2026-06-26",
    "author": "Evan Carter",
    "subject": "Baton: admin-approval fixes APPLIED to prod (no longer staged)"
  },
  {
    "hash": "b6aba549994c8809e6fa452764065811ffef8cf7",
    "date": "2026-06-26",
    "author": "Evan Carter",
    "subject": "Harden 780/781 against prod drift: rebuild on verified-live bodies"
  },
  {
    "hash": "04a5ab485dfb75b38cd4228b9d9e508718071417",
    "date": "2026-06-25",
    "author": "Evan Carter",
    "subject": "OUTSTANDING: drift-audit landmines (db push unsafe; 781 regresses apple-name guard; 780 needs index first) + skip-date/Recents flag"
  },
  {
    "hash": "0f0bd6981a2621fabe5b4dc7d5f7a8237711ef9c",
    "date": "2026-06-25",
    "author": "Evan Carter",
    "subject": "Move LGBTQ+ tag to end of atmosphere thought-tags list (display order only; stored values unchanged) Co-Authored-By: Claude Opus 4.8 <noreply@anthropic.com>"
  },
  {
    "hash": "c234bd72c2a1bff9de04f3f1a6ea598f4cdcaa79",
    "date": "2026-06-25",
    "author": "Evan Carter",
    "subject": "Baton: log staged admin-approval work + apple-name/auth-gap/dup-audit status"
  },
  {
    "hash": "c7dd925c23161322b05a7bf2c5f7b7328b14d988",
    "date": "2026-06-25",
    "author": "Evan Carter",
    "subject": "Admin approval: enter both corpuses on approve + real merge for apple_fallback (staged, not applied)"
  },
  {
    "hash": "94f19b2b6767e517b925a37e8db4b4741880397d",
    "date": "2026-06-25",
    "author": "Evan Carter",
    "subject": "Track applied migration 20260776000000 (admin_set_approved_venue_photo, live in prod) + bump shado-admin pointer to the RPC-rewire commit"
  }
];
